export const countryReducerConstant = {
  GET_ALL_COUNTRIES: "GET_ALL_COUNTRIES",
  GET_ALL_STATES: "GET_ALL_STATES",
  GET_ALL_CITIES: "GET_ALL_CITIES",
  RESET_STATES: "RESET_STATES",
  RESET_CITIES: "RESET_CITIES",
  ALL_LANGUAGES: "ALL_LANGUAGES",
};
